module.exports = __webpack_public_path__ + "img/section2-boxImg4.0d0d891b.png";